if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then(registration => {
    // Service worker can delete cache storage
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  });
}